const firebaseConfig = {
  apiKey: 'AIzaSyC_FhbY2WJAd5DkaXbYdaQFNgUWYxHF4AA',
  authDomain: 'trip-buddy-6be03.firebaseapp.com',
  projectId: 'trip-buddy-6be03',
  storageBucket: 'trip-buddy-6be03.appspot.com',
  messagingSenderId: '170146115022',
  appId: '1:170146115022:web:c81d488d6383f778840f9f',
  measurementId: 'G-FMYR3ZQ8MS',
};
const googleMapApiKey = 'AIzaSyDmrY595Mhv_mMPzSIeShgF69AcMqIkIA4';

export { firebaseConfig, googleMapApiKey };
